import React, { useState } from 'react';
import {
  Table, Tag, Space, Button, Card, Form, Input, Select, DatePicker,
  Typography, message,
} from 'antd';
import { SearchOutlined, ReloadOutlined, ExportOutlined } from '@ant-design/icons';
import { getDomainNode } from './couponData';

const { RangePicker } = DatePicker;
const { Title, Text } = Typography;

// ══════════════════════════════════════════════
//  常量与 Mock 数据
// TODO: 联调时替换为接口数据
// ══════════════════════════════════════════════

const COUPON_TYPES = {
  exchange: { label: '兑换券', color: 'blue' },
  discount: { label: '折扣券', color: 'orange' },
  fullcut: { label: '满减券', color: 'purple' },
};

// 卡券（券码所属卡券）
const MOCK_COUPONS = [
  { id: 'CPN2026010100001', name: '新年活动兑换券' },
  { id: 'CPN2026070100003', name: '海外用户满减券' },
  { id: 'CPN2025110100004', name: '双十一体验券' },
  { id: 'CPN2026060100006', name: '618大促满减券' },
  { id: 'CPN2026080100007', name: '新用户专享兑换券' },
  { id: 'CPN2026050100008', name: '企业大客户9折券' },
  { id: 'CPN2026030100010', name: '春季回馈兑换券' },
  { id: 'CPN2026091000011', name: '客服补偿兑换券' },
];

const getCoupon = (id) => MOCK_COUPONS.find((c) => c.id === id);

// 绑定套餐
const MOCK_PACKAGES = [
  { id: 'WKfjwcCxUO', name: '7天循环录像【12个月】' },
  { id: 'PKG_30D_1M', name: '30天不间断录像【1个月】' },
  { id: 'PKG_7D_6M', name: '7天循环录像【6个月】' },
  { id: 'PKG_3D_1M', name: '3天循环录像【1个月】' },
  { id: 'PKG_USER_AI', name: 'AI智能体【1个月】' },
  { id: 'PKG_USER_3D', name: '3天事件云存【1个月】' },
  { id: 'PKG_USER_30D', name: '30天事件云存【12个月】' },
];

const getPackageName = (id) => MOCK_PACKAGES.find((p) => p.id === id)?.name || '-';

// 核销记录（券核销后回流，只读）
// domainNode：券码所属域节点（来源券码）
// target/targetType：发放目标（可为空）；targetUid：发放目标映射的 UID
// usedUid：核销用户 UID（券最终在用户上生效）；usedVia：核销入口标识
const MOCK_RECORDS = [
  { key: '1', code: 'HM7F3K9A2B1C', couponId: 'CPN2026010100001', domainNode: 'china', type: 'exchange', packageId: 'WKfjwcCxUO', target: 'QEBUHL26012700IA', targetType: 'License', targetUid: '1600010d40003cad', issuedAt: '2026-01-02 10:00:00', usedAt: '2026-01-08 15:32:10', usedTarget: 'QEBUHL26012700IA', usedViaType: 'License', usedUid: '1600010d40003cad', orderNo: 'C20260108033210-13-OXOWU', discountAmount: '¥ 149.00' },
  { key: '4', code: 'HM1A3S5D7F9G', couponId: 'CPN2026070100003', domainNode: 'oversea', type: 'fullcut', packageId: 'PKG_7D_6M', target: '-', targetType: '-', issuedAt: '-', usedAt: '2026-07-06 08:05:19', usedTarget: 'user_8801@example.com', usedViaType: '邮箱', usedUid: '3800010d40003aaa', orderNo: 'C20260706080519-11-PLM90', discountAmount: '$ 3.00' },
  { key: '5', code: 'HM4X6C8V0B2N', couponId: 'CPN2025110100004', domainNode: 'china', type: 'exchange', packageId: 'PKG_USER_3D', target: '3800010d40003ccc', targetType: 'UID', targetUid: '3800010d40003ccc', issuedAt: '2025-11-01 12:00:00', usedAt: '2025-11-06 19:44:02', usedTarget: '3800010d40003ccc', usedViaType: 'UID', usedUid: '3800010d40003ccc', orderNo: 'C20251106194402-99-QAZWS', discountAmount: '¥ 12.90' },
  { key: '6', code: 'HM7Y9U1I3O5P', couponId: 'CPN2025110100004', domainNode: 'china', type: 'exchange', packageId: 'PKG_USER_3D', target: '3800010d40003ddd', targetType: 'UID', targetUid: '3800010d40003ddd', issuedAt: '2025-11-01 12:00:00', usedAt: '2025-11-12 13:20:55', usedTarget: '3800010d40003ddd', usedViaType: 'UID', usedUid: '3800010d40003ddd', orderNo: 'C20251112132055-99-QAZWS', discountAmount: '¥ 12.90' },
  { key: '7', code: 'HM2V4B6N8M0Q', couponId: 'CPN2026030100010', domainNode: 'china', type: 'exchange', packageId: 'WKfjwcCxUO', target: '8613800000002', targetType: '手机号', targetUid: '1600010d40003ppp', issuedAt: '2026-03-01 10:30:00', usedAt: '2026-03-04 12:20:33', usedTarget: '8613800000002', usedViaType: '手机号', usedUid: '1600010d40003ppp', orderNo: 'C20260304122033-13-OXOWU', discountAmount: '¥ 149.00' },
  { key: '8', code: 'HM9P1L3K5J7H', couponId: 'CPN2026050100008', domainNode: 'china', type: 'discount', packageId: 'PKG_3D_1M', target: '2700010d40003bbb', targetType: 'UID', targetUid: '2700010d40003bbb', issuedAt: '2026-04-02 09:15:00', usedAt: '2026-04-03 21:03:57', usedTarget: '2700010d40003bbb', usedViaType: 'UID', usedUid: '2700010d40003bbb', orderNo: 'C20260403210357-44-RE92K', discountAmount: '¥ 8.80' },
  { key: '9', code: 'HM2W4E6R8T0Y', couponId: 'CPN2026080100007', domainNode: 'bxmz', type: 'exchange', packageId: 'PKG_USER_AI', target: '2700010d40003bbb', targetType: 'UID', targetUid: '2700010d40003bbb', issuedAt: '2026-08-02 09:20:00', usedAt: '2026-08-09 18:52:14', usedTarget: '2700010d40003bbb', usedViaType: 'UID', usedUid: '2700010d40003bbb', orderNo: 'C20260809185214-44-RE92K', discountAmount: '¥ 39.00' },
  { key: '10', code: 'HM6C8V0B2N4M', couponId: 'CPN2026060100006', domainNode: 'china', type: 'fullcut', packageId: 'PKG_USER_30D', target: 'user_9310@example.com', targetType: '邮箱', targetUid: '1600010d40003qqq', issuedAt: '2026-06-05 10:00:00', usedAt: '2026-06-11 10:30:08', usedTarget: 'user_9310@example.com', usedViaType: '邮箱', usedUid: '1600010d40003qqq', orderNo: 'C20260611103008-11-PLM90', discountAmount: '¥ 30.00' },
  { key: '11', code: 'HM9A1S3D5F7G', couponId: 'CPN2026091000011', domainNode: 'oversea', type: 'exchange', packageId: 'PKG_USER_3D', target: '1600010d40003cad', targetType: 'UID', targetUid: '1600010d40003cad', issuedAt: '2026-09-10 15:00:00', usedAt: '2026-09-12 11:12:41', usedTarget: '1600010d40003cad', usedViaType: 'UID', usedUid: '1600010d40003cad', orderNo: 'C20260912111241-13-OXOWU', discountAmount: '¥ 12.90' },
  { key: '12', code: 'HM3E5R7T9Y1U', couponId: 'CPN2026050100008', domainNode: 'china', type: 'discount', packageId: 'PKG_3D_1M', target: 'QEBUHL26030505NP', targetType: 'License', targetUid: '1600010d40003nnn', issuedAt: '2026-05-02 09:00:00', usedAt: '2026-05-18 16:44:23', usedTarget: 'QEBUHL26030505NP', usedViaType: 'License', usedUid: '1600010d40003nnn', orderNo: 'C20260518164423-13-OXOWU', discountAmount: '¥ 8.80' },
];

const CouponRecords = () => {
  const [searchForm] = Form.useForm();
  const [filters, setFilters] = useState({});

  const handleSearch = () => {
    setFilters(searchForm.getFieldsValue());
  };

  const handleResetSearch = () => {
    searchForm.resetFields();
    setFilters({});
  };

  const filteredRecords = MOCK_RECORDS.filter((r) => {
    const { code, couponName, couponId, type, packageName, packageId, usedRange } = filters;
    const coupon = getCoupon(r.couponId);
    if (code) {
      const kw = String(code).trim().toLowerCase();
      if (!r.code.toLowerCase().includes(kw)) return false;
    }
    if (couponName) {
      const kw = String(couponName).trim().toLowerCase();
      if (!(coupon?.name || '').toLowerCase().includes(kw)) return false;
    }
    if (couponId) {
      const kw = String(couponId).trim().toLowerCase();
      if (!r.couponId.toLowerCase().includes(kw)) return false;
    }
    if (type && r.type !== type) return false;
    if (packageName) {
      const kw = String(packageName).trim().toLowerCase();
      if (!(getPackageName(r.packageId) || '').toLowerCase().includes(kw)) return false;
    }
    if (packageId) {
      const kw = String(packageId).trim().toLowerCase();
      if (!r.packageId.toLowerCase().includes(kw)) return false;
    }
    if (usedRange && usedRange.length === 2 && usedRange[0] && usedRange[1]) {
      const start = usedRange[0].format('YYYY-MM-DD');
      const end = usedRange[1].format('YYYY-MM-DD');
      const usedDate = r.usedAt.slice(0, 10);
      if (usedDate < start || usedDate > end) return false;
    }
    return true;
  });

  const handleExport = () => {
    if (filteredRecords.length === 0) {
      message.warning('没有可导出的数据');
      return;
    }
    // TODO: 联调时替换为接口导出
    const headers = ['券码', '所属卡券ID', '所属卡券名称', '券类型', '适用节点', '绑定套餐', '套餐ID', '发放目标', '发放目标类型', '发放目标UID', '核销目标', '核销目标类型', '核销目标UID', '发放时间', '核销时间', '关联订单', '优惠金额'];
    const rows = filteredRecords.map((r) => [
      r.code,
      r.couponId,
      getCoupon(r.couponId)?.name || '-',
      COUPON_TYPES[r.type].label,
      getDomainNode(r.domainNode).label,
      getPackageName(r.packageId),
      r.packageId,
      r.target,
      r.targetType,
      r.targetUid || '-',
      r.usedTarget || '-',
      r.usedViaType || '-',
      r.usedUid || '-',
      r.issuedAt,
      r.usedAt,
      r.orderNo,
      r.discountAmount,
    ].join(','));
    const csvContent = [headers.join(','), ...rows].join('\n');
    const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `核销记录导出_${new Date().toLocaleDateString()}.csv`;
    link.click();
    URL.revokeObjectURL(url);
    message.success('导出成功');
  };

  const columns = [
    { title: '券码', dataIndex: 'code', key: 'code', width: 160 },
    {
      title: '所属卡券',
      key: 'coupon',
      width: 220,
      render: (_, record) => (
        <div style={{ fontSize: '12px' }}>
          <div>{getCoupon(record.couponId)?.name || '-'}</div>
          <div style={{ color: '#999' }}>ID: {record.couponId}</div>
        </div>
      ),
    },
    {
      title: '券类型',
      dataIndex: 'type',
      key: 'type',
      width: 100,
      render: (type) => <Tag color={COUPON_TYPES[type].color}>{COUPON_TYPES[type].label}</Tag>,
    },
    {
      title: '适用节点',
      key: 'domainNode',
      width: 110,
      render: (_, record) => {
        const node = getDomainNode(record.domainNode);
        return <Tag color={node.color}>{node.label}</Tag>;
      },
    },
    {
      title: '实际核销套餐',
      key: 'package',
      width: 220,
      render: (_, record) => (
        <div style={{ fontSize: '12px' }}>
          <div>{getPackageName(record.packageId)}</div>
          <div style={{ color: '#999' }}>ID: {record.packageId}</div>
        </div>
      ),
    },
    {
      title: '发放目标',
      key: 'target',
      width: 200,
      render: (_, record) => (
        <div style={{ fontSize: '12px' }}>
          <div>{record.target}</div>
          <div style={{ color: '#999' }}>{record.targetType}</div>
        </div>
      ),
    },
    {
      title: '发放目标(UID)',
      key: 'targetUid',
      width: 180,
      render: (_, record) => record.targetUid || <span style={{ color: '#ccc' }}>-</span>,
    },
    {
      title: '核销目标',
      key: 'usedTarget',
      width: 200,
      render: (_, record) => (
        <div style={{ fontSize: '12px' }}>
          <div>{record.usedTarget || '-'}</div>
          <div style={{ color: '#999' }}>{record.usedViaType || '-'}</div>
        </div>
      ),
    },
    {
      title: '核销目标(UID)',
      key: 'usedUid',
      width: 180,
      render: (_, record) => record.usedUid || <span style={{ color: '#ccc' }}>-</span>,
    },
    { title: '发放时间', dataIndex: 'issuedAt', key: 'issuedAt', width: 170 },
    { title: '核销时间', dataIndex: 'usedAt', key: 'usedAt', width: 170 },
    {
      title: '关联订单',
      dataIndex: 'orderNo',
      key: 'orderNo',
      width: 230,
      render: (val) => <Text copyable style={{ fontSize: '12px' }}>{val}</Text>,
    },
    {
      title: '优惠金额',
      dataIndex: 'discountAmount',
      key: 'discountAmount',
      width: 120,
      render: (val) => <Text strong style={{ color: '#cf1322' }}>{val}</Text>,
    },
  ];

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: 16 }}>
        <Title level={4} style={{ marginBottom: 8 }}>核销记录</Title>
        <Text type="secondary" style={{ fontSize: 12 }}>
          C 端用户核销卡券后回流，仅平台运营可见，记录只读不可编辑。券最终在用户（UID）上生效：发放目标可为空，核销用户必有 UID。
        </Text>
      </div>

      <Card style={{ marginBottom: '16px' }}>
        <Form form={searchForm} layout="inline" onFinish={handleSearch}>
          <Form.Item name="code" style={{ marginBottom: 0 }}>
            <Input placeholder="券码" style={{ width: 170 }} allowClear />
          </Form.Item>
          <Form.Item name="couponName" style={{ marginBottom: 0 }}>
            <Input placeholder="卡券名称" style={{ width: 170 }} allowClear />
          </Form.Item>
          <Form.Item name="couponId" style={{ marginBottom: 0 }}>
            <Input placeholder="卡券ID" style={{ width: 170 }} allowClear />
          </Form.Item>
          <Form.Item name="type" style={{ marginBottom: 0 }}>
            <Select placeholder="券类型" style={{ width: 130 }} allowClear>
              {Object.entries(COUPON_TYPES).map(([value, cfg]) => (
                <Select.Option key={value} value={value}>{cfg.label}</Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="packageName" style={{ marginBottom: 0 }}>
            <Input placeholder="套餐名称" style={{ width: 200 }} allowClear />
          </Form.Item>
          <Form.Item name="packageId" style={{ marginBottom: 0 }}>
            <Input placeholder="套餐ID" style={{ width: 170 }} allowClear />
          </Form.Item>
          <Form.Item name="usedRange" style={{ marginBottom: 0 }}>
            <RangePicker style={{ width: 240 }} placeholder={['核销开始时间', '核销结束时间']} />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Space>
              <Button type="primary" htmlType="submit" icon={<SearchOutlined />}>查询</Button>
              <Button icon={<ReloadOutlined />} onClick={handleResetSearch}>重置</Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>

      <Card>
        <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ color: '#999', fontSize: 13 }}>共 {filteredRecords.length} 条核销记录</span>
          <Button icon={<ExportOutlined />} onClick={handleExport}>导出</Button>
        </div>
        <Table
          columns={columns}
          dataSource={filteredRecords}
          scroll={{ x: 2260 }}
          pagination={{ pageSize: 10, showSizeChanger: true, showTotal: (t) => `共 ${t} 条记录` }}
        />
      </Card>
    </div>
  );
};

export default CouponRecords;
